import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { jwtDecode } from 'jwt-decode';
import { IJWTIDToken } from "../types/IJWTIDToken";
import axios from '../components/UtilityHelpers/AxiosHelper';
import { useNavigate } from 'react-router-dom';

const LoginCheck = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    // const appURL = import.meta.env.VITE_APP_URL;


    const runLoginCheck = async(upi: string, email: string, firstName: string, lastName: string) => {
        console.log('From loginCheck');
        try {
            const response = await axios.post("login", JSON.stringify({upi, email, firstName, lastName}),
                {
                    headers: {'Content-Type':'application/json'},
                    withCredentials: true
                }
            );

            const accessToken = response?.data?.accessToken;
            const roles = response?.data?.roles;
            auth?.setAccessToken(accessToken);
            auth?.setUpi(upi);
            auth?.setEmail(email);
            auth?.setFirstName(response.data.firstName);
            auth?.setLastName(response.data.lastName);
            auth?.setNotificationType(response.data.notification_type)
            auth?.setRoles(roles);
            
            window.localStorage.removeItem("codeChallenge");
            window.localStorage.removeItem("codeVerifier");

            const redirectPath = window.localStorage.getItem("redirectAfterLogin");

            window.localStorage.removeItem("redirectAfterLogin");

            console.log('Number 41', redirectPath);

            if (!redirectPath) {
                navigate('/', { replace: true });
            } else {
                navigate(redirectPath, { replace: true });
            }
        } catch (error) {

        }
    }

    useEffect(() => {   
        const code = auth?.authService.getCodeFromLocation(window.location);
        auth?.setPersist(true);

        let dCode: string = code ?? "";

        const formData = new FormData();

        auth?.authService
            .fetchToken(dCode)
            .then((t) => {
                const decoded = jwtDecode(t.id_token) as IJWTIDToken;
                const upi = decoded.preferred_username;
                const email = decoded.email;
                const firstName = decoded.given_name;
                const lastName = decoded.family_name;

                runLoginCheck(upi, email, firstName, lastName);
            })
    }, []);

    useEffect(() => {
        const persistsValue = auth?.persist as boolean;

        localStorage.setItem("persist", JSON.stringify(persistsValue));
    }, [auth?.persist])
    return (
        <></>
    )
}

export default LoginCheck;